import { axios } from "../utils/axios.create";

export enum EventTypeEnum {
  JOURNAL = "JOURNAL",
  STEP_COMPLETION = "STEP_COMPLETION",
  GOAL_COMPLETION = "GOAL_COMPLETION",
  SUPERVISION_ACTIVITY = "SUPERVISION_ACTIVITY",
  IN_HOUSE_SERVICE = "IN_HOUSE_SERVICE",
  EXTERNAL_PROVIDER_SERVICE = "EXTERNAL_PROVIDER_SERVICE",
  REDEEMED = "REDEEMED",
  ACCOUNT_CREATION = "ACCOUNT_CREATION",
  APPOINTMENT_SCHEDULED = "APPOINTMENT_SCHEDULED",
  APPOINTMENT_CANCELLED = "APPOINTMENT_CANCELLED",
  CHECK_IN_VALIDATED = "CHECK_IN_VALIDATED",
  APPOINTMENT_CREATION = "APPOINTMENT_CREATION",
  APPOINTMENT_MISSED = "APPOINTMENT_MISSED",
  APPOINTMENT_MISSED_REASON = "APPOINTMENT_MISSED_REASON",
  MANUAL_REIMBURSEMENT = "MANUAL_REIMBURSEMENT",
  CONTEXTUAL_AGENT = "CONTEXTUAL_AGENT",
}

export enum RewardConfigurationType {
  FixedLadder = "FIXED_LADDER",
  ProgrammableLadder = "PROGRAMMABLE_LADDER",
}

export interface FixedLadderConfiguration {
  index: number;
  points: number;
}

export interface ProgrammableLadderConfiguration {
  startValue: number;
  stepValue: number;
  maxValue: number;
  resetValue: number;
}

export interface InvalidResult {
  invalidResultType: string;
  rewardForInvalid: string;
  resetRuleType: string;
  specificIndex: number;
}

export interface RewardsEngine {
  _id: string;
  accountId: string;
  programId: string;
  eventType: string;
  event: string;
  rewardConfigurationType: RewardConfigurationType;
  fixedLadderConfiguration?: FixedLadderConfiguration[];
  programmableLadderConfiguration?: ProgrammableLadderConfiguration[];
  invalidResult?: InvalidResult;
  createdAt: string;
  createdBy: string;
  updatedAt?: string;
  updatedBy?: string;
  isDeleted: boolean;
  orgUnitIds: string[];
}

const findAll = async (
  options: { eventType?: string; event?: string } = {}
): Promise<RewardsEngine[]> => {
  const { eventType, event } = options;
  const params = new URLSearchParams();

  if (eventType) params.append("eventType", eventType);
  if (event) params.append("event", event);

  return axios
    .get(`/rewards-engine?${params.toString()}`)
    .then((res) => res.data.body)
    .catch((err) => Promise.reject(err.response.data));
};

const findOne = async (id: string): Promise<RewardsEngine> => {
  return axios
    .get(`/rewards-engine/find/${id}`)
    .then((res) => res.data.body)
    .catch((err) => Promise.reject(err.response.data));
};

const create = async (data: Partial<RewardsEngine>): Promise<RewardsEngine> => {
  return axios
    .post("/rewards-engine", data)
    .then((res) => res.data.body)
    .catch((err) => Promise.reject(err.response.data));
};

const update = async ({
  id,
  data,
}: {
  id: string;
  data: Partial<RewardsEngine>;
}): Promise<RewardsEngine> => {
  return axios
    .put(`/rewards-engine/${id}`, data)
    .then((res) => res.data.body)
    .catch((err) => Promise.reject(err.response.data));
};

const archive = async (id: string): Promise<void> => {
  return axios
    .patch(`/rewards-engine/archive/${id}`)
    .then(() => undefined)
    .catch((err) => Promise.reject(err.response.data));
};

export const rewardsEngineService = {
  findAll,
  findOne,
  create,
  update,
  archive,
};
